const base_api = `${process.env.REACT_APP_API_URL}/api`
const fetch_header = { 
    "Content-Type": "application/json",
    "X-API-KEY": process.env.REACT_APP_API_KEY 
}

export {
    base_api,
    fetch_header
}